import { createContext, ReactNode, useContext, useReducer } from 'react';

// State interface
interface MenuViewState {
  isGrid: boolean;
}

// Action types
type MenuViewAction = { type: 'TOGGLE_VIEW' };

// Initial state
const initialState: MenuViewState = {
  isGrid: true,
};

// Reducer
const menuViewReducer = (state: MenuViewState, action: MenuViewAction): MenuViewState => {
  switch (action.type) {
    case 'TOGGLE_VIEW':
      return {
        ...state,
        isGrid: !state.isGrid,
      };
    default:
      return state;
  }
};

// Context
interface MenuViewContextType {
  state: MenuViewState;
  toggleView: () => void;
}

const MenuViewContext = createContext<MenuViewContextType | undefined>(undefined);

// Provider component
interface MenuViewProviderProps {
  children: ReactNode;
}

export const MenuViewProvider = ({ children }: MenuViewProviderProps) => {
  const [state, dispatch] = useReducer(menuViewReducer, initialState);

  const toggleView = () => dispatch({ type: 'TOGGLE_VIEW' });

  const value: MenuViewContextType = {
    state,
    toggleView,
  };

  return <MenuViewContext.Provider value={value}>{children}</MenuViewContext.Provider>;
};

// Hook to use the context
export const useMenuView = (): MenuViewContextType => {
  const context = useContext(MenuViewContext);
  if (context === undefined) {
    throw new Error('useMenuView must be used within a MenuViewProvider');
  }
  return context;
};
